import { Engine1Proxy, SagasProxy, RestApiProxy } from 'com-gyf-webcore-servicehub';

let CuentaTarjetaSaldosManager = function () {

    const isQuery = false;
    const deleteInstance = false;

    function _crearCuentaTarjetaSaldo(saldoGlobal, cuentaTarjetaId, sagasCallback, viewCallback) {
        let localValues = mapearCuentaTarjetaSaldo(saldoGlobal, cuentaTarjetaId);
        ejecutarSagas(localValues, 'SAGA_CUENTA_TARJETA_SALDOS', sagasCallback, viewCallback);

        //Engine1Proxy.AddEventSourcingDataRequest(localValues, 'EVENTSOURCING_BAJA_CUENTA_TARJETA', 'Tarjetas', 'ADMINEMPCUETAR', null, true, null, deleteInstance);
    }


    /**
       * 
       * @param {any} localValues
       * @param {any} saga
       * @param {any} sagasCallback
       * @param {any} viewCallback
       */
    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {

        SagasProxy.AddSagaRequests(localValues, saga, "TARJETAS", "ADMINEMPCUETAR");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, "ADMINEMPCUETAR");
    }

    /**
     * 
     * @param {any} cuentaTarjeta
     */
    function mapearCuentaTarjetaSaldo(saldoGlobal, cuentaTarjetaId) {
        let now = new Date();
        let localValues = {
            'CUENTA_TARJETA_SALDO_CONTAINER': {
                "FechaCierre": now,
                "FechaVencimiento": null,
                "PagoMinimo": null,
                "SaldoCierrePesos": saldoGlobal.SaldoPesos,
                "SaldoCierreDolares": saldoGlobal.SaldoDolar,
                "CuentaTarjetaId": cuentaTarjetaId,
                "CarteraId": null,
                "FormaPagoId": null,
                "CuentaBancariaId": null,
                "EstadoCuentaId": null,
                "FormaDebitoId": null
            }

        };
        return localValues;
    }

    return {
        CrearCuentaTarjetaSaldo: function (saldoGlobal, cuentaTarjetaId, sagasCallback, viewCallback) {
            return _crearCuentaTarjetaSaldo(saldoGlobal, cuentaTarjetaId, sagasCallback, viewCallback);
        }
    }
};

let cuentaTarjetaSaldosManager = new CuentaTarjetaSaldosManager();
export default cuentaTarjetaSaldosManager;
